import adminApi from "./admin";

export async function loginApi(email: string, password: string) {
	try {
		const { data } = await adminApi.post("/users/login", {
			email,
			password,
		});

		return data;
	} catch (error) {
		console.error(error);
		throw new Error("Credenciais inválidas ou erro de conexão");
	}
}

export async function checkTokenApi(token: string) {
	try {
		const { data } = await adminApi.get("/users/me", {
			withCredentials: true,
			headers: {
				"Content-Type": "application/json",
				Authorization: `Bearer ${token}`,
			},
		});

		return data;
	} catch (error) {
		console.error(error);
		throw new Error("Token não verificado");
	}
}
